import React from 'react';
import { connect } from 'react-redux';

import './styles.css';
import { RootState } from 'redux/reducers/rootReducer';
import { Theme } from 'redux/reducers/rootReducer';

interface ScreenContainerProps {
    children: React.ReactNode;
    isActiveTicketShown: boolean;
    currentTheme: Theme;
}

const ScreenContainer: React.FC<ScreenContainerProps> = ({ children, isActiveTicketShown, currentTheme }) => {
    const { backgroundImage, backgroundColor } = currentTheme ?? {};

    const activeStyle = {
        ...(backgroundImage
            ? { backgroundImage: `url(${backgroundImage})` }
            : backgroundColor
            ? { backgroundColor }
            : {}),
    };
    return (
        <div className="screen-container" style={isActiveTicketShown ? activeStyle : {}}>
            {children}
        </div>
    );
};

export default connect((state: RootState) => ({
    isActiveTicketShown: state.isActiveTicketShown,
    currentTheme: state.currentTheme,
}))(ScreenContainer);
